import React, { useState, useEffect, useCallback,useRef } from "react";
import { useLoading } from "../../../context/LoadingContext";
import {
  FormControl,
  FormHelperText,
  Select,
  MenuItem,
  TextField,
  Typography,
  Button,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import {
  fetchData,
  postQuery,
} from "../../Requirement/services/RequirementServices";
import { v4 as uuidv4 } from "uuid";
import dayjs from "dayjs";

const RequirementForm = ({
  formMode,
  setFormMode,
  selectedRequirement,
  setIsFormVisible,
  productList,
  allProductMaster,
  activeUser,
  buyerInfo,
  totalItems,
  setModal,
  searchRequirements,
  searchValues,
  navigate,
}) => {
  const { setLoading } = useLoading();
  const [formValues, setFormValues] = useState({
    product: "",
    grade: "",
    origin: "",
    destination: "",
    deliveryPeriod: "",
    quantity: "",
    incoterms: "",
    paymentTerms: "",
    packaging: "",
    deliveryPort: "",
    deliveryPeriodFrom: null,
    deliveryPeriodTill: null,
    deliveryPeriodTillRange: "",
    validUntil: null,
    validUntilRange: "",
  });
  const [initialFormValues, setInitialFormValues] = useState({});
  const [productGradeList, setProductGradeList] = useState([]);
  const [formProduct, setFormProduct] = useState([]);
  const [countrymaster, setCountryMaster] = useState([]);
  const [paymentTermMaster, setPaymentTermMaster] = useState([]);
  const [incotermsMaster, setIncotermsMaster] = useState([]);
  const [allPortList, setAllPortList] = useState([]);
  const [formPortList, setFormPortList] = useState([]);
  const [packagingMaster, setPackagingMaster] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});

  const packagingOptions = [
    { id: "1", name: "Sack" },
    { id: "2", name: "Big Bag" },
  ];

  const loadProductGrades = useCallback(
    async (productName) => {
      setLoading(true);
      try {
        const [allGrades] = await Promise.all([
          fetchData({
            target: "listProducts",
            userOrder: "ProductName",
            rowStart: 0,
            pageSize: 500,
            filterTerms: { ProductName: productName, Status: "ACTIVE" },
          }),
        ]);
        setProductGradeList(allGrades.items || []);
      } catch (error) {
        console.error("Error loading product grades: ", error);
        setProductGradeList([]);
      } finally {
        setLoading(false);
      }
    },
    [setLoading]
  );

  const loadFormProductInfo = useCallback(async (productName, grade) => {
    if (!productName || !grade) return;
    try {
      const response = await fetchData({
        target: "listProducts",
        userOrder: "ProductName",
        rowStart: 0,
        pageSize: 1,
        filterTerms: { ProductName: productName, Grade: grade },
      });
      setFormProduct(response.items[0] || []);
    } catch (error) {
      console.error("Error loading form product info:", error);
      setFormProduct([]);
    }
  }, []);

  // const loadCountries = useCallback(async () => {
  //   setLoading(true);
  //   try {
  //     const [allCountries] = await Promise.all([
  //       fetchData({
  //         target: "listDropDownOptions",
  //         userOrder: "Value",
  //         rowStart: 0,
  //         pageSize: 1000,
  //         filterTerms: { Type: "Country" },
  //       }),
  //     ]);
  //     setCountryMaster(allCountries.items || []);
  //   } catch (error) {
  //     console.error("Error loading countries: ", error);
  //     setCountryMaster([]);
  //   } finally {
  //     setLoading(false);
  //   }
  // }, [setLoading]);

  // const loadPaymentTerms = useCallback(async () => {
  //   setLoading(true);
  //   try {
  //     const [allPaymentTerms] = await Promise.all([
  //       fetchData({
  //         target: "listDropDownOptions",
  //         userOrder: "Value",
  //         rowStart: 0,
  //         pageSize: 1000,
  //         filterTerms: { Type: "paymentTerms" },
  //       }),
  //     ]);
  //     setPaymentTermMaster(allPaymentTerms.items || []);
  //   } catch (error) {
  //     console.error("Error loading paymentTerms: ", error);
  //     setPaymentTermMaster([]);
  //   } finally {
  //     setLoading(false);
  //   }
  // }, [setLoading]);

  // const loadIncoterms = useCallback(async () => {
  //   setLoading(true);
  //   try {
  //     const [allIncoterms] = await Promise.all([
  //       fetchData({
  //         target: "listDropDownOptions",
  //         userOrder: "Value",
  //         rowStart: 0,
  //         pageSize: 1000,
  //         filterTerms: { Type: "Incoterms" },
  //       }),
  //     ]);
  //     setIncotermsMaster(allIncoterms.items || []);
  //   } catch (error) {
  //     console.error("Error loading Incoterms: ", error);
  //     setIncotermsMaster([]);
  //   } finally {
  //     setLoading(false);
  //   }
  // }, [setLoading]);

  const loadFormPorts = useCallback(
    async (country) => {
      setLoading(true);
      try {
        const matchingPort = allPortList.filter((p) => p.Subtype === country);
        console.log("matchingPort@@", matchingPort);
        setFormPortList(matchingPort);
      } catch (error) {
        console.error("Error loading ports: ", error);
        setFormPortList([]);
      } finally {
        setLoading(false);
      }
    },
    [setLoading, allPortList]
  );

  function groupByType(items) {
    return items.reduce((acc, cur) => {
      const type = cur.Type;
      if (!acc[type]) acc[type] = [];
      acc[type].push(cur);
      return acc;
    }, {});
  }
  const dropdownsLoaded = useRef(false);
  const loadAllDropdowns = useCallback(async () => {
    if (dropdownsLoaded.current) return;
    setLoading(true);
    try {
      const response = await fetchData({
        target: "listDropDownOptions",
        userOrder: "Value",
        rowStart: 0,
        pageSize: 100000,
      });

      const items = response.items ?? [];

      const groups = groupByType(items);

      setCountryMaster(groups.Country ?? []);
      setPaymentTermMaster(groups.paymentTerms ?? []);
      setIncotermsMaster(groups.Incoterms ?? []);
      setPackagingMaster(groups.packaging ?? []);
      setAllPortList(groups.port ?? []);
    } catch (err) {
      console.error("Failed to load dropdown options:", err);
      setModal({
        show: true,
        type: "error",
        title: "Error",
        message: "Could not load dropdown lists. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  }, []);

  const validateFormField = useCallback(
    (name, value) => {
      const newErrors = { ...errors };
      const today = dayjs().startOf("day");

      switch (name) {
        case "product":
          if (!value) newErrors.product = "Product is required";
          else delete newErrors.product;
          break;
        case "grade":
          if (!value) newErrors.grade = "Grade is required";
          else delete newErrors.grade;
          break;
        case "quantity":
          if (!value) newErrors.quantity = "Quantity is required";
          else if (isNaN(value) || Number(value) <= 0)
            newErrors.quantity = "Quantity must be a positive number";
          else delete newErrors.quantity;
          break;
        case "origin":
          if (!value) newErrors.origin = "Origin country is required";
          else delete newErrors.origin;
          break;
        case "destination":
          if (!value) newErrors.destination = "Destination country is required";
          else delete newErrors.destination;
          break;
        case "deliveryPort":
          if (!value) newErrors.deliveryPort = "Delivery port is required";
          else delete newErrors.deliveryPort;
          break;
        case "packaging":
          if (!value) newErrors.packaging = "Packaging is required";
          else delete newErrors.packaging;
          break;
        case "incoterms":
          if (!value) newErrors.incoterms = "Incoterms is required";
          else delete newErrors.incoterms;
          break;
        case "paymentTerms":
          if (!value) newErrors.paymentTerms = "Payment terms is required";
          else delete newErrors.paymentTerms;
          break;
        case "deliveryPeriodFrom":
          if (!value)
            newErrors.deliveryPeriodFrom = "Delivery start date is required";
          else if (!dayjs(value).isValid())
            newErrors.deliveryPeriodFrom = "Invalid start date format";
          else if (dayjs(value).isBefore(today))
            newErrors.deliveryPeriodFrom = "Start date cannot be in the past";
          else delete newErrors.deliveryPeriodFrom;
          break;
        case "deliveryPeriodTill":
          if (!value)
            newErrors.deliveryPeriodTill = "Delivery end date is required";
          else if (!dayjs(value).isValid())
            newErrors.deliveryPeriodTill = "Invalid end date format";
          else if (
            formValues.deliveryPeriodFrom &&
            dayjs(value).isBefore(dayjs(formValues.deliveryPeriodFrom))
          )
            newErrors.deliveryPeriodTill = "End date must be after start date";
          else delete newErrors.deliveryPeriodTill;
          break;
        case "validUntil":
          if (!value) newErrors.validUntil = "Valid until date is required";
          else if (!dayjs(value).isValid())
            newErrors.validUntil = "Invalid valid until date format";
          else if (dayjs(value).isBefore(today))
            newErrors.validUntil = "Valid until date must be in the future";
          else delete newErrors.validUntil;
          break;
        default:
          break;
      }

      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    },
    [errors, formValues.deliveryPeriodFrom]
  );

  const handleSubmit = async () => {
    // Validate all fields before submission
    const fieldsToValidate = [
      "product",
      "grade",
      "quantity",
      "origin",
      "destination",
      "deliveryPort",
      "packaging",
      "incoterms",
      "paymentTerms",
      "deliveryPeriodFrom",
      "deliveryPeriodTill",
      "validUntil",
    ];

    let isValid = true;
    fieldsToValidate.forEach((field) => {
      if (!validateFormField(field, formValues[field])) {
        isValid = false;
      }
    });

    if (!isValid) {
      setModal({
        show: true,
        type: "error",
        title: "Validation Error",
        message: "Please correct the errors in the form before submitting.",
        autoClose: false,
      });
      return;
    }

    let insertedRequirementsID = null;
    let insertedRequirementsNo = null;
    const insertedPaymentConditionsIDs = [];
    setSubmitted(true);
    setLoading(true);

    try {
      const packageingValue = { item: formValues.packaging, size: "" };
      const curreDate = new Date();
      const reqNoDate = dayjs(curreDate).format("YYYYMMDD");
      const reqCount = totalItems + 1;
      const reqNumber = `1${reqNoDate}${reqCount}`;

      const requestedQuantity = parseInt(formValues.quantity || 0);
      const requestedProductID = formProduct.ProductID || "";
      const category = formProduct.ProductCategoryID || "";
      const productType = "";
      const priceOffered = "0.00";
      const deliveryPeriodTill = formValues.deliveryPeriodTill || "";
      const deliveryPeriodFrom = formValues.deliveryPeriodFrom || "";
      const validUntil = formValues.validUntil || "";
      const incoterm = formValues.incoterms || "";
      const destination = formValues.destination || "";
      const deliveryPort = formValues.deliveryPort || "";
      const locations = destination + "~" + deliveryPort;
      const originCountry = formValues.origin || "";
      const paymentTerms = formValues.paymentTerms || "";
      let gpEmail = activeUser;
      let recordStatus = "Approved";

      if (formMode === "edit") {
        const requirementsInput = {
          RequirementsID: selectedRequirement.RequirementsID,
        };

        // Only update changed fields
        if (
          formValues.product !== initialFormValues.product ||
          formValues.grade !== initialFormValues.grade
        ) {
          requirementsInput.ProductID = requestedProductID;
        }
        if (formValues.quantity !== initialFormValues.quantity) {
          requirementsInput.Quantity = requestedQuantity;
          requirementsInput.RequestedQuantity = requestedQuantity;
        }
        if (formValues.incoterms !== initialFormValues.incoterms) {
          requirementsInput.Incoterm = incoterm;
        }
        if (formValues.origin !== initialFormValues.origin) {
          requirementsInput.OriginCountry = originCountry;
        }
        if (
          formValues.destination !== initialFormValues.destination ||
          formValues.deliveryPort !== initialFormValues.deliveryPort
        ) {
          requirementsInput.DeliveryLocation = locations;
        }
        if (
          formValues.deliveryPeriodFrom !== initialFormValues.deliveryPeriodFrom
        ) {
          requirementsInput.DeliveryPeriodFrom = deliveryPeriodFrom;
        }
        if (
          formValues.deliveryPeriodTill !== initialFormValues.deliveryPeriodTill
        ) {
          requirementsInput.DeliveryPeriodTill = deliveryPeriodTill;
          requirementsInput.DeliveryDate = deliveryPeriodTill;
        }
        if (formValues.validUntil !== initialFormValues.validUntil) {
          requirementsInput.ValidUntil = validUntil;
        }
        if (formValues.packaging !== initialFormValues.packaging) {
          requirementsInput.ProductPackaging = packageingValue;
        }
        if (formValues.paymentTerms !== initialFormValues.paymentTerms) {
          requirementsInput.PaymentTerms = paymentTerms;
        }

        if (Object.keys(requirementsInput).length > 1) {
          const body = {
            target: "updateRequirements",
            requirementsInput,
          };
          await postQuery(body);
          setModal({
            show: true,
            type: "success",
            title: "Success!",
            message: "Requirement updated successfully.",
            autoClose: false,
            nextAction: () => {
              navigate("/global-partner/requirement");
              searchRequirements(searchValues);
            },
          });
        }
      } else if (formMode === "add") {
        const body = {
          target: "createRequirements",
          ExtraInfo: {
            ProductName: formValues.product,
            Grade: formValues.grade,
          },
          requirementsInput: {
            RequirementsID: uuidv4(),
            RequirementNumber: reqNumber,
            GPEmailID: gpEmail,
            BuyerEmailID: " ",
            CreatedByEmailID: activeUser,
            ProductID: requestedProductID,
            Quantity: requestedQuantity,
            Price: priceOffered,
            DeliveryDate: deliveryPeriodTill,
            RequirementDate: dayjs(curreDate).format("YYYY-MM-DD"),
            MarketPlacement: "No",
            ValidUntil: validUntil,
            Incoterm: incoterm,
            DeliveryLocation: locations,
            DeliveryPeriodFrom: deliveryPeriodFrom,
            DeliveryPeriodTill: deliveryPeriodTill,
            OriginCountry: originCountry,
            ProductPackaging: packageingValue,
            RequestedQuantity: requestedQuantity,
            PriceOffered: priceOffered,
            Status: recordStatus,
            CategoryType: "requirement",
            Deleted: 0,
            PaymentTerms: paymentTerms,
          },
        };

        const result = await postQuery(body);
        if (!result || !result.items)
          throw new Error("Failed to create requirement.");
        insertedRequirementsID = result.items.RequirementsID;
        insertedRequirementsNo = result.items.RequirementNumber;
        // const bodyProductInfo = {
        //   target: "createRequirementProductInfo",
        //   requirementProductInfoInput: {
        //     RequirementProductInfoID: uuidv4(),
        //     RequirementsID: insertedRequirementsID,
        //     Category: category,
        //     ProductID: requestedProductID,
        //     ProductTypeID: productType,
        //     Deleted: 0,
        //   },
        // };

        // await postQuery(bodyProductInfo);

        // const paymentConditionsID = uuidv4();
        // const bodyPC = {
        //   target: "createPaymentConditions",
        //   paymentConditionsInput: {
        //     PaymentConditionsID: paymentConditionsID,
        //     RequirementsID: insertedRequirementsID,
        //     PaymentOptions: formValues.paymentTerms || "",
        //     TermsConditionsFilePath: "",
        //     OthersFilePath: "",
        //     Deleted: 0,
        //   },
        // };

        // await postQuery(bodyPC);
        // insertedPaymentConditionsIDs.push(paymentConditionsID);

        // const bodyRTH = {
        //   target: "createRequirementTxnHistory",
        //   requirementTxnHistoryInput: {
        //     RequirementTxnHistoryID: uuidv4(),
        //     RequirementsID: insertedRequirementsID,
        //     ActionedByEmail: activeUser,
        //     Status: recordStatus,
        //     Deleted: 0,
        //   },
        // };
        // await postQuery(bodyRTH);

        setModal({
          show: true,
          type: "success",
          title: "Success!",
          message: `Requirement ${insertedRequirementsNo} created successfully.`,
          autoClose: false,
          nextAction: () => {
            navigate("/global-partner/requirement");
            searchRequirements(searchValues);
          },
        });
      }
    } catch (error) {
      console.error("Submission error:", error);
      try {
        await Promise.all(
          insertedPaymentConditionsIDs.map(async (paymentConditionsID) => {
            const bodyDelPC = {
              target: "deletePaymentConditions",
              PaymentConditionsID: paymentConditionsID,
            };
            await postQuery(bodyDelPC);
          })
        );
        if (insertedRequirementsID) {
          const bodyDelR = {
            target: "deleteRequirements",
            RequirementsID: insertedRequirementsID,
          };
          await postQuery(bodyDelR);
        }
      } catch (rollbackError) {
        console.error("Rollback error:", rollbackError);
        setModal({
          show: true,
          type: "error",
          title: "Rollback Error!",
          message:
            "Failed to clean up data after error. Please contact support.",
          autoClose: false,
        });
        setLoading(false);
        setSubmitted(false);
        return;
      }
      setModal({
        show: true,
        type: "error",
        title: "Error!",
        message: error.message || "Failed to submit requirement.",
        autoClose: false,
      });
    } finally {
      setLoading(false);
      setSubmitted(false);
      if (formMode === "add") {
        setFormValues({
          product: "",
          grade: "",
          origin: "",
          destination: "",
          deliveryPeriod: "",
          quantity: "",
          incoterms: "",
          paymentTerms: "",
          packaging: "",
          deliveryPort: "",
          deliveryPeriodFrom: null,
          deliveryPeriodTill: null,
          deliveryPeriodTillRange: "",
          validUntil: null,
          validUntilRange: "",
        });
        setIsFormVisible(false);
      }
    }
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
  
    setFormValues((prev) => {
      const newValues = { ...prev, [name]: value };
  
      if (name === "product") {
        newValues.grade = "";
        setProductGradeList([]);
        setFormProduct([]);
        if (value) {
          loadProductGrades(value); // Fire and forget
        }
      }
      if (name === "destination") {
        newValues.deliveryPort = "";
        setFormPortList([]);
        if (value) loadFormPorts(value);
      }
  
      return newValues;
    });
  
    validateFormField(name, value);
  
    // Grade change: load product info
    if (name === "grade" && formValues.product && value) {
      loadFormProductInfo(formValues.product, value);
    }
  };

  const parseProductPackaging = (packagingString) => {
    try {
      const cleanedString = packagingString.replace(/[{}]/g, "");
      const keyValuePairs = cleanedString.split(", ").reduce((acc, pair) => {
        const [key, value] = pair.split("=");
        acc[key] = value;
        return acc;
      }, {});
      return { item: keyValuePairs.item || "", size: keyValuePairs.size || "" };
    } catch (error) {
      console.error("Error parsing ProductPackaging:", error);
      return { item: "", size: "" };
    }
  };

  const loadPaymentConditions = useCallback(async (requirementsID) => {
    try {
      const response = await fetchData({
        target: "listPaymentConditions",
        userOrder: "PaymentConditionsID",
        rowStart: 0,
        pageSize: 100,
        filterTerms: { RequirementsID: requirementsID },
      });
      return response.items || [];
    } catch (error) {
      console.error("Error loading payment conditions:", error);
      return [];
    }
  }, []);

  const handleEdit = () => {
    setFormMode("edit");
  };

  useEffect(() => {
    let isMounted = true;
  
    const initializeForm = async () => {
      // Load dropdowns only once
      if (countrymaster.length === 0) {
        await loadAllDropdowns();
      }
  
      if ((formMode === "edit" || formMode === "view") && selectedRequirement && isMounted) {
        const product = allProductMaster.find(
          (p) => p.ProductID === selectedRequirement.ProductID
        );

        
        const [destination] = selectedRequirement.DeliveryLocation?.split("~") || [""];
  
        const packaging = parseProductPackaging(selectedRequirement.ProductPackaging || "");
  
        const initialValues = {
          product: product?.ProductName || "",
          grade: product?.Grade || "",
          origin: selectedRequirement.OriginCountry || "",
          destination: destination || "",
          deliveryPort: selectedRequirement.DeliveryLocation?.split("~")[1] || "",
          quantity: selectedRequirement.Quantity?.toString() || "",
          incoterms: selectedRequirement.Incoterm || "",
          paymentTerms: selectedRequirement.PaymentTerms?.toString() || "",
          packaging: packaging.item || "",
          deliveryPeriodFrom: selectedRequirement.DeliveryPeriodFrom
            ? dayjs(selectedRequirement.DeliveryPeriodFrom)
            : null,
          deliveryPeriodTill: selectedRequirement.DeliveryPeriodTill
            ? dayjs(selectedRequirement.DeliveryPeriodTill)
            : null,
          validUntil: selectedRequirement.ValidUntil
            ? dayjs(selectedRequirement.ValidUntil)
            : null,
          deliveryPeriodTillRange: "custom",
          validUntilRange: "custom",
        };
  
        setFormValues(initialValues);
        setInitialFormValues(initialValues);
  
        // Only load grades/ports if not already loaded
        if (product && !productGradeList.some(p => p.Grade === product.Grade)) {
          await loadProductGrades(product.ProductName);
        }
        if (product) {
          await loadFormProductInfo(product.ProductName, product.Grade);
        }
        if (destination && formPortList.length === 0) {
          await loadFormPorts(destination);
        }
      } else if (formMode === "add") {
        setFormValues({ /* reset */ });
        setInitialFormValues({});
        setProductGradeList([]);
        setFormProduct([]);
        setFormPortList([]);
      }
    };
  
    initializeForm();
  
    return () => { isMounted = false; };
  }, [
    formMode,
    selectedRequirement,
    allProductMaster,
    countrymaster.length,
    loadAllDropdowns,
    loadProductGrades,
    loadFormProductInfo,
    loadFormPorts,
    // DO NOT include productGradeList.length or formPortList.length
  ]);

  // useEffect(() => {
  //   loadAllDropdowns();
    
  //   if (formMode === "edit" || formMode === "view") {
  //     if (selectedRequirement) {
  //       const packaging = parseProductPackaging(
  //         selectedRequirement.ProductPackaging || ""
  //       );
  //       const product = allProductMaster.find(
  //         (p) => p.ProductID === selectedRequirement.ProductID
  //       );
  //       const [destination, deliveryPort] =
  //         selectedRequirement.DeliveryLocation?.split("~") || ["", ""];

  //       const initialValues = {
  //         product: product?.ProductName || "",
  //         grade: product?.Grade || "",
  //         origin: selectedRequirement.OriginCountry || "",
  //         destination: destination || "",
  //         deliveryPort: deliveryPort || "",
  //         quantity: selectedRequirement.Quantity?.toString() || "",
  //         incoterms: selectedRequirement.Incoterm || "",
  //         paymentTerms: selectedRequirement.PaymentTerms?.toString() || "",
  //         packaging: packaging.item || "",
  //         deliveryPeriodFrom: selectedRequirement.DeliveryPeriodFrom
  //           ? dayjs(selectedRequirement.DeliveryPeriodFrom).format("YYYY-MM-DD")
  //           : null,
  //         deliveryPeriodTill: selectedRequirement.DeliveryPeriodTill
  //           ? dayjs(selectedRequirement.DeliveryPeriodTill).format("YYYY-MM-DD")
  //           : null,
  //         validUntil: selectedRequirement.ValidUntil
  //           ? dayjs(selectedRequirement.ValidUntil).format("YYYY-MM-DD")
  //           : null,
  //         deliveryPeriodTillRange: "custom",
  //         validUntilRange: "custom",
  //       };

  //       setFormValues(initialValues);
  //       setInitialFormValues(initialValues);

  //       if (product) {
  //         loadProductGrades(product.ProductName);
  //         loadFormProductInfo(product.ProductName, product.Grade);
  //       }
  //       if (destination) {
  //         loadFormPorts(destination);
  //       }
  //       // Removed the loadPaymentConditions override to prevent clearing the value from selectedRequirement.PaymentTerms
  //       // If you need paymentConditions in the future, uncomment and adjust logic to fallback to requirements.PaymentTerms if empty
  //     }
  //   } else if (formMode === "add") {
  //     setFormValues({
  //       product: "",
  //       grade: "",
  //       origin: "",
  //       destination: "",
  //       deliveryPeriod: "",
  //       quantity: "",
  //       incoterms: "",
  //       paymentTerms: "",
  //       packaging: "",
  //       deliveryPort: "",
  //       deliveryPeriodFrom: null,
  //       deliveryPeriodTill: null,
  //       deliveryPeriodTillRange: "",
  //       validUntil: null,
  //       validUntilRange: "",
  //     });
  //     setInitialFormValues({});
  //     setProductGradeList([]);
  //     setFormProduct([]);
  //     setFormPortList([]);
  //   }
  // }, [
  //   formMode,
  //   selectedRequirement,
  //   allProductMaster,
  //   // loadProductGrades,
  //   // loadFormProductInfo,
  //   loadAllDropdowns,
  //   loadFormPorts,
  // ]);

  const uniquePackagingTypes = [
    ...new Set(packagingMaster.map((item) => item.Subtype).filter(Boolean)),
  ];
  console.log("uniquePackagingTypes@", uniquePackagingTypes);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div className="form-section" style={{ marginTop: "20px", display:"block" }}>
        <div className="table-header">
          <div className="header-text">
            <div className="head-text">
              {formMode === "add" && "Add Requirement"}
              {formMode === "edit" && "Edit Requirement"}
              {formMode === "view" && "View Requirement"}
            </div>
          </div>
          <div className="head-btn">
            {formMode === "view" && (
              <Button className="btn btn-question" onClick={handleEdit}>
                Edit
              </Button>
            )}
            {(formMode === "add" || formMode === "edit") && (
              <Button
                className="btn btn-question"
                onClick={handleSubmit}
                disabled={submitted}
                sx={{
                  backgroundColor: "#de6b14",
                  color: "#fff",
                  marginRight: "5px",
                }}
              >
                {submitted
                  ? "Submitting..."
                  : formMode === "edit"
                  ? "Update"
                  : "Submit"}
              </Button>
            )}
            <Button
              className="btn btn-question"
              onClick={() => setIsFormVisible(false)}
            >
              Cancel
            </Button>
          </div>
        </div>
        <div className="row" style={{ marginTop: "20px" }}>
          <div className="col-md-3">
            <div className="mb-3">
              <FormControl
                sx={{ minWidth: "100%" }}
                error={!!errors.product}
                disabled={formMode === "view"}
              >
                <Typography variant="body2">Product *</Typography>
                <Select
                  name="product"
                  value={formValues.product}
                  onChange={(e) => {
                    handleFormChange(e);
                  }}
                  displayEmpty
                  sx={{ backgroundColor: "white" }}
                  inputProps={{ "aria-label": "Select Product" }}
                >
                  <MenuItem value="" disabled>
                    Select Product
                  </MenuItem>
                  {productList.map((p) => (
                    <MenuItem key={p.ProductID} value={p.ProductName}>
                      {p.ProductName}
                    </MenuItem>
                  ))}
                </Select>
                {errors.product && (
                  <FormHelperText>{errors.product}</FormHelperText>
                )}
              </FormControl>
            </div>
          </div>
          <div className="col-md-3">
            <div className="mb-3">
              <FormControl
                sx={{ minWidth: "100%" }}
                error={!!errors.grade}
                disabled={formMode === "view" || !formValues.product}
              >
                <Typography variant="body2">Grade *</Typography>
                <Select
                  name="grade"
                  value={formValues.grade}
                  onChange={(e) => {
                    handleFormChange(e);
                    loadFormProductInfo(formValues.product, e.target.value);
                  }}
                  displayEmpty
                  sx={{ backgroundColor: "white" }}
                  inputProps={{ "aria-label": "Select Grade" }}
                >
                  <MenuItem value="" disabled>
                    Select Grade
                  </MenuItem>
                  {productGradeList.map((p) => (
                    <MenuItem key={p.ProductID} value={p.Grade}>
                      {p.Grade}
                    </MenuItem>
                  ))}
                </Select>
                {errors.grade && (
                  <FormHelperText>{errors.grade}</FormHelperText>
                )}
              </FormControl>
            </div>
          </div>
          <div className="col-md-3">
            <div className="mb-3">
              <FormControl
                sx={{ minWidth: "100%" }}
                error={!!errors.origin}
                disabled={formMode === "view"}
              >
                <Typography variant="body2">Origin *</Typography>
                <Select
                  name="origin"
                  value={formValues.origin}
                  onChange={handleFormChange}
                  displayEmpty
                  sx={{ backgroundColor: "white" }}
                  inputProps={{ "aria-label": "Select Origin" }}
                >
                  <MenuItem value="" disabled>
                    Select Origin
                  </MenuItem>
                  {countrymaster.map((p) => (
                    <MenuItem key={p.ID} value={p.Value}>
                      {p.Value}
                    </MenuItem>
                  ))}
                </Select>
                {errors.origin && (
                  <FormHelperText>{errors.origin}</FormHelperText>
                )}
              </FormControl>
            </div>
          </div>
          <div className="col-md-3">
            <div className="mb-3">
              <FormControl
                sx={{ minWidth: "100%" }}
                error={!!errors.destination}
                disabled={formMode === "view"}
              >
                <Typography variant="body2">Destination *</Typography>
                <Select
                  name="destination"
                  value={formValues.destination}
                  onChange={handleFormChange}
                  displayEmpty
                  sx={{ backgroundColor: "white" }}
                  inputProps={{ "aria-label": "Select Destination" }}
                >
                  <MenuItem value="" disabled>
                    Select Destination
                  </MenuItem>
                  {countrymaster.map((p) => (
                    <MenuItem key={p.ID} value={p.Value}>
                      {p.Value}
                    </MenuItem>
                  ))}
                </Select>
                {errors.destination && (
                  <FormHelperText>{errors.destination}</FormHelperText>
                )}
              </FormControl>
            </div>
          </div>
          <div className="col-md-3">
            <div className="mb-3">
              <Typography>Quantity (MT) *</Typography>
              <TextField
                type="number"
                name="quantity"
                value={formValues.quantity}
                onChange={handleFormChange}
                error={!!errors.quantity}
                helperText={errors.quantity}
                sx={{ backgroundColor: "white", width: "100%" }}
                placeholder="Enter Quantity"
                disabled={formMode === "view"}
              />
            </div>
          </div>
          <div className="col-md-3">
            <div className="mb-3">
              <FormControl
                sx={{ minWidth: "100%" }}
                error={!!errors.incoterms}
                disabled={formMode === "view"}
              >
                <Typography variant="body2">Inco Terms</Typography>
                <Select
                  name="incoterms"
                  value={formValues.incoterms}
                  onChange={handleFormChange}
                  displayEmpty
                  sx={{ backgroundColor: "white" }}
                  inputProps={{ "aria-label": "Select Inco Terms" }}
                >
                  <MenuItem value="" disabled>
                    Select Inco Terms
                  </MenuItem>
                  {incotermsMaster.map((incotermOption, index) => (
                    <MenuItem key={index} value={incotermOption.Value}>
                      {incotermOption.Value}
                    </MenuItem>
                  ))}
                </Select>
                {errors.incoterms && (
                  <FormHelperText>{errors.incoterms}</FormHelperText>
                )}
              </FormControl>
            </div>
          </div>
          <div className="col-md-3">
            <div className="mb-3">
              <FormControl
                sx={{ minWidth: "100%" }}
                error={!!errors.paymentTerms}
                disabled={formMode === "view"}
              >
                <Typography variant="body2">Payment Terms</Typography>
                <Select
                  name="paymentTerms"
                  value={formValues.paymentTerms}
                  onChange={handleFormChange}
                  displayEmpty
                  sx={{ backgroundColor: "white" }}
                  inputProps={{ "aria-label": "Select Payment Terms" }}
                >
                  <MenuItem value="" disabled>
                    Select Payment Terms
                  </MenuItem>
                  {paymentTermMaster.map((option, index) => (
                    <MenuItem key={index} value={option.Value}>
                      {option.Value}
                    </MenuItem>
                  ))}
                </Select>
                {errors.paymentTerms && (
                  <FormHelperText>{errors.paymentTerms}</FormHelperText>
                )}
              </FormControl>
            </div>
          </div>
          <div className="col-md-3">
            <div className="mb-3">
              <FormControl
                sx={{ minWidth: "100%" }}
                error={!!errors.packaging}
                disabled={formMode === "view"}
              >
                <Typography variant="body2">Packaging</Typography>
                <Select
                  name="packaging"
                  value={formValues.packaging}
                  onChange={handleFormChange}
                  displayEmpty
                  sx={{ backgroundColor: "white" }}
                  inputProps={{ "aria-label": "Select Packaging" }}
                >
                  <MenuItem value="" disabled>
                    Select Packaging
                  </MenuItem>
                  {/* {packagingOptions.map((option) => (
                    <MenuItem key={option.id} value={option.name}>
                      {option.name}
                    </MenuItem>
                  ))} */}
                  {uniquePackagingTypes.map((type) => (
                                      <MenuItem key={type} value={type}>
                                        {type}
                                      </MenuItem>
                                    ))}
                </Select>
                {errors.packaging && (
                  <FormHelperText>{errors.packaging}</FormHelperText>
                )}
              </FormControl>
            </div>
          </div>
          <div className="col-md-3">
            <div className="mb-3">
              <FormControl
                sx={{ minWidth: "100%" }}
                error={!!errors.deliveryPort}
                disabled={formMode === "view"}
              >
                <Typography variant="body2">Delivery Port</Typography>
                <Select
                  name="deliveryPort"
                  value={formValues.deliveryPort}
                  onChange={handleFormChange}
                  displayEmpty
                  sx={{ backgroundColor: "white" }}
                  inputProps={{ "aria-label": "Select Delivery Port" }}
                >
                  <MenuItem value="" disabled>
                    Select Delivery Port
                  </MenuItem>
                  {formPortList.length > 0 ? (
                    formPortList.map((option, index) => (
                      <MenuItem key={index} value={option.Value}>
                        {option.Value}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem value="ACTIVE">Loading...</MenuItem>
                  )}
                </Select>
                {errors.deliveryPort && (
                  <FormHelperText>{errors.deliveryPort}</FormHelperText>
                )}
              </FormControl>
            </div>
          </div>
          <div className="col-md-3">
            <div className="mb-3">
              <FormControl
                sx={{ minWidth: "100%" }}
                error={!!errors.deliveryPeriodFrom}
                disabled={formMode === "view"}
              >
                <Typography variant="body2">Delivery (Start) *</Typography>
                <DatePicker
                  value={
                    formValues.deliveryPeriodFrom
                      ? dayjs(formValues.deliveryPeriodFrom)
                      : null
                  }
                  onChange={(date) => {
                    const newValue = date ? date.format("YYYY-MM-DD") : null;
                    setFormValues((prev) => ({
                      ...prev,
                      deliveryPeriodFrom: newValue,
                      deliveryPeriodTillRange: newValue
                        ? "custom"
                        : prev.deliveryPeriodTillRange,
                    }));
                    validateFormField("deliveryPeriodFrom", newValue);
                    if (newValue && formValues.deliveryPeriodTill) {
                      validateFormField(
                        "deliveryPeriodTill",
                        formValues.deliveryPeriodTill
                      );
                    }
                  }}
                  minDate={dayjs()}
                  format="DD-MM-YYYY"
                  slotProps={{
                    textField: {
                      sx: { backgroundColor: "white", width: "100%" },
                      placeholder: "DD-MM-YYYY",
                      error: !!errors.deliveryPeriodFrom,
                      helperText: errors.deliveryPeriodFrom,
                    },
                  }}
                />
              </FormControl>
            </div>
          </div>
          <div className="col-md-3">
            <div className="mb-3">
              <FormControl
                sx={{ minWidth: "100%" }}
                error={!!errors.deliveryPeriodTill}
                disabled={formMode === "view"}
              >
                <Typography variant="body2">Delivery (End) *</Typography>
                <DatePicker
                  value={
                    formValues.deliveryPeriodTill
                      ? dayjs(formValues.deliveryPeriodTill)
                      : null
                  }
                  onChange={(date) => {
                    const newValue = date ? date.format("YYYY-MM-DD") : null;
                    setFormValues((prev) => ({
                      ...prev,
                      deliveryPeriodTill: newValue,
                      deliveryPeriodTillRange: newValue
                        ? "custom"
                        : prev.deliveryPeriodTillRange,
                    }));
                    validateFormField("deliveryPeriodTill", newValue);
                  }}
                  minDate={
                    formValues.deliveryPeriodFrom
                      ? dayjs(formValues.deliveryPeriodFrom)
                      : dayjs()
                  }
                  format="DD-MM-YYYY"
                  disabled={!formValues.deliveryPeriodFrom}
                  slotProps={{
                    textField: {
                      sx: { backgroundColor: "white", width: "100%" },
                      placeholder: "DD-MM-YYYY",
                      error: !!errors.deliveryPeriodTill,
                      helperText: errors.deliveryPeriodTill,
                    },
                  }}
                />
              </FormControl>
            </div>
          </div>
          <div className="col-md-3">
            <div className="mb-3">
              <FormControl
                sx={{ minWidth: "100%" }}
                error={!!errors.validUntil}
                disabled={formMode === "view"}
              >
                <Typography variant="body2">Valid Until *</Typography>
                <DatePicker
                  value={
                    formValues.validUntil ? dayjs(formValues.validUntil) : null
                  }
                  onChange={(date) => {
                    const newValue = date ? date.format("YYYY-MM-DD") : null;
                    setFormValues((prev) => ({
                      ...prev,
                      validUntil: newValue,
                      validUntilRange: newValue
                        ? "custom"
                        : prev.validUntilRange,
                    }));
                    validateFormField("validUntil", newValue);
                  }}
                  minDate={dayjs()}
                  format="DD-MM-YYYY"
                  slotProps={{
                    textField: {
                      sx: { backgroundColor: "white", width: "100%" },
                      placeholder: "DD-MM-YYYY",
                      error: !!errors.validUntil,
                      helperText: errors.validUntil,
                    },
                  }}
                />
              </FormControl>
            </div>
          </div>
        </div>
      </div>
    </LocalizationProvider>
  );
};

export default RequirementForm;
